import type { ReactNode } from "react";

export function SettingGroup({ children, card }: { children: ReactNode; card?: boolean }) {
	return (
		<div className={card ? "rounded-lg border border-border divide-y divide-border overflow-hidden" : "divide-y divide-border/40"}>
			{children}
		</div>
	);
}
